/**
 * Country service
 */

import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ICertificate } from '../interfaces';
import { HttpService } from './http.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../environments/environment';
import { API_URL_PREFIX } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class CertificateService extends HttpService {
  public baseUrl: string = '';

  // private urlStr = environment.webcomponent_api_endpoint.api_url+ API_URL_PREFIX
  public state: {
    certificates$: BehaviorSubject<ICertificate[]>;
    loading$: BehaviorSubject<boolean>;
  } = {
      certificates$: new BehaviorSubject<ICertificate[]>([]),
      loading$: new BehaviorSubject<boolean>(false)
    };

  constructor(private httpClient: HttpClient, public injector: Injector) {
    super(httpClient);
    this.baseUrl = `${environment.portal_api_endpoint}${API_URL_PREFIX}`;
  }

  /**
   * Fetch certificates
   */
  public fetchCertificates(projectId: number, accessToken: string): Observable<ICertificate[]> {
    const url = `${this.baseUrl}certificates/v2/${projectId}`;
    return this.get<ICertificate[]>(
      url,
      null,
      new HttpHeaders().set('Authorization', `Bearer ${accessToken}`)
    ).pipe(tap((res: ICertificate[]) => this.state.certificates$.next(res)));
  }

  /**
   * Create a certificate
   */
  public createCertificate(formData: FormData, accessToken: string): Observable<ICertificate> {
    const url = `${this.baseUrl}certificates/v2`;
    return this.post<ICertificate>(
      url,
      formData,
      new HttpHeaders().set('Authorization', `Bearer ${accessToken}`)
    ).pipe(
      tap((res: ICertificate) => {
        this.updateObservable(this.state.certificates$, (list: ICertificate[]) => {
          return [res, ...list];
        });
      })
    );
  }

  /**
   * Delete a certificate
   */
  public deleteCertificate(certUuid: string, accessToken: string, isAdminPortal?: boolean): Observable<null> {
    const url = `${this.baseUrl}certificates/v2?certUuid=${certUuid}`;
    let params = {};
    params['certUuid'] = certUuid;
    return this.delete<null>(
      url,
      null,
      new HttpHeaders().set('Authorization', `Bearer ${accessToken}`)
    ).pipe(
      tap(() => {
        this.updateObservable(this.state.certificates$, (list: ICertificate[]) => {
          return list;
        });
      })
    );
  }

}
